export default __webpack_public_path__ + "static/media/flag_usa.ea63c518.webp";